import { forwardRef } from 'react';
import Spinner from './Spinner';

const variants = {
  primary: 'bg-primary-600 text-white shadow-xs hover:bg-primary-700 focus-visible:ring-primary-500',
  secondary: 'bg-white text-gray-700 border border-gray-200 shadow-xs hover:bg-gray-50 focus-visible:ring-primary-500',
  danger: 'bg-danger-600 text-white shadow-xs hover:bg-danger-700 focus-visible:ring-danger-500',
  ghost: 'text-gray-600 hover:bg-gray-100 hover:text-gray-900',
};

const sizeClasses = {
  sm: 'px-3 py-1.5 text-[12px]',
  md: 'px-4 py-2 text-[13px]',
  lg: 'px-5 py-2.5 text-[14px]',
};

const Button = forwardRef(function Button(
  { variant = 'primary', size = 'md', isLoading, icon: Icon, children, className = '', disabled, ...props },
  ref
) {
  return (
    <button
      ref={ref}
      disabled={disabled || isLoading}
      className={`inline-flex items-center justify-center gap-2 rounded-[6px] font-medium transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 ${variants[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {isLoading ? <Spinner size="sm" className="text-current" /> : Icon ? <Icon className="h-4 w-4" /> : null}
      {children}
    </button>
  );
});

export default Button;
